// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"2":"ffc2ae57","174":"06aa3a04"}[chunkId] + ".js";
};